import { Diamond, MessageCircle, ArrowRight, Sparkles } from "lucide-react";
import { WA_LINK, CONTACT_ICONS } from "./shared";

export default function BottomCta({ city, t }) {
  return (
    <section className="relative bg-[#0A0807] text-white overflow-hidden" data-testid="weddings-bottom-cta">
      <div className="absolute inset-0">
        <img src={city.heroImage} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0807] via-[#0A0807]/85 to-[#0A0807]" />
      </div>
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none"
           style={{ backgroundImage: "radial-gradient(#D4B896 0.5px, transparent 0.5px)", backgroundSize: "26px 26px" }} />

      <div className="relative max-w-4xl mx-auto px-5 sm:px-10 py-20 sm:py-28 lg:py-36 text-center">
        <div className="flex items-center justify-center gap-2 sm:gap-3 mb-7 sm:mb-9">
          <span className="w-10 sm:w-16 h-px bg-[#C9A87C]" />
          <Diamond className="w-3 h-3 sm:w-4 sm:h-4 text-[#D4B896]" />
          <span className="w-10 sm:w-16 h-px bg-[#C9A87C]" />
        </div>

        <h2 className="text-4xl sm:text-6xl lg:text-7xl leading-[1.05] mb-6 sm:mb-8"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}>
          <span className="text-white">{t.bottomCtaTitle}</span><br/>
          <span className="italic text-[#D4B896]">{t.bottomCtaTitleAccent}</span>
        </h2>
        <p className="text-sm sm:text-base lg:text-lg text-white/65 font-light leading-relaxed max-w-xl mx-auto mb-10 sm:mb-12">
          {t.bottomCtaSubtitle}
        </p>

        <a href={WA_LINK} target="_blank" rel="noopener noreferrer"
           className="group relative inline-flex items-center gap-3 px-10 sm:px-14 py-4 sm:py-5 bg-gradient-to-r from-[#D4B896] to-[#B8966F] hover:from-[#E0C8A8] hover:to-[#C9A87C] text-[#0A0807] text-[12px] sm:text-[13px] tracking-[0.25em] sm:tracking-[0.3em] font-semibold transition-all duration-500 rounded-sm shadow-[0_15px_50px_-10px_rgba(212,184,150,0.5)] hover:shadow-[0_20px_70px_-10px_rgba(212,184,150,0.7)] hover:-translate-y-0.5"
           data-testid="weddings-bottom-cta-btn">
          <MessageCircle className="w-4 h-4 sm:w-5 sm:h-5" />
          <span>{t.contactCta}</span>
          <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 transition-transform group-hover:translate-x-1" />
        </a>

        <div className="mt-12 sm:mt-16 grid grid-cols-2 lg:grid-cols-4 gap-x-5 gap-y-7 max-w-3xl mx-auto border-t border-white/10 pt-10 sm:pt-12">
          {t.contactBadges.map((b, i) => {
            const Icon = CONTACT_ICONS[i] || Sparkles;
            return (
              <div key={i} className="text-center">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border border-[#C9A87C]/40 flex items-center justify-center mx-auto mb-3">
                  <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-[#D4B896]" strokeWidth={1.5} />
                </div>
                <div className="text-[13px] sm:text-[14px] font-medium text-white mb-1 leading-tight">{b.title}</div>
                <div className="text-[11px] sm:text-[12px] text-white/55 font-light leading-tight">{b.subtitle}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
